module.exports = __webpack_public_path__ + "img/aboutus-case3.4e5f3ea6.png";